import { render, staticRenderFns } from "./MzReviews.vue?vue&type=template&id=0fbeae2d&"
import script from "./MzReviews.vue?vue&type=script&lang=js&"
export * from "./MzReviews.vue?vue&type=script&lang=js&"
import style0 from "./MzReviews.vue?vue&type=style&index=0&id=0fbeae2d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports